import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React , {useEffect,useState} from "react";
import Loader from '../../../utils/Loader';
import { useShowManageSubModuleQuery,useUpdateManageSubModuleMutation,useGetCourseListQuery,useShowManageModuleQuery} from "../../../Services/api";
export default function UpdateStudent(props) {
    const notify = () => '';
    
      const {
        data: ShowManageSubModule,
        isLoading: isGetLoading,
      } =  useShowManageSubModuleQuery({  params:props['id']});
      const [UpdateManageSubModule,isLoading] = useUpdateManageSubModuleMutation();
      const getSubModule= ShowManageSubModule?.data[0];
      var  defaultValues={
        lesson_id:getSubModule?.lesson_id,
        coursecode:getSubModule?.coursecode,
        sublesson_name:getSubModule?.sublesson_name,
        sublesson_content:getSubModule?.sublesson_content,
        sublesson_status:getSubModule?.sublesson_status,
        sublesson_rserial:getSubModule?.sublesson_rserial,
      };
      const { reset,register, handleSubmit, formState: { errors }} = useForm({defaultValues:defaultValues});

       // eslint-disable-next-line react-hooks/exhaustive-deps 
      useEffect(() => {
        reset(defaultValues)
      },[getSubModule]) 
    const updateManageSubModuleList = (values,e) => {
        const formData = new FormData();
        formData.append('file', values.sublesson_content[0]);
        formData.append('coursecode', values.coursecode);
        formData.append('lesson_id', values.lesson_id);
        formData.append('sublesson_name', values.sublesson_name);
        formData.append('sublesson_rserial', values.sublesson_rserial);
        formData.append('sublesson_status', values.sublesson_status);
        formData.append('id', props['id'] );
        formData.append('type', 'sublesson_content');
       
        ///
        UpdateManageSubModule(formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
              toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const [courseCode,setCourseCode] = useState(0);
    const findLession=(e)=>{
        setCourseCode(e.target.value);
    }
    const { 
        data: showManageModule        
    } = useShowManageModuleQuery({  params:courseCode});
    const { 
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    if(isGetLoading) return  <Loader></Loader>
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Resource</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                        <h5 className="card-title">Update Resource</h5>
                        <form onSubmit={handleSubmit(updateManageSubModuleList)} >
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                                <div className="col-sm-10">
                                <select  {...register("coursecode", { required: true })} className="form-control" onChange={findLession}>
                                    <option value="">Select Course</option>                                           

                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.coursecode && <span  className="text-danger">Course is required</span>}
                            
                                </div>
                            </div>
                        
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Module Name</label>
                                <div className="col-sm-10">
                                <select  {...register("lesson_id", { required: true })} className="form-control" >
                                    <option value="">Select Module</option>                                           

                                    {                            
                                    showManageModule?.data?.map((item) => {
                                        return (

                                            <option key={item.lesson_id} value={item.lessonid}>{item.lesson_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.lesson_id && <span  className="text-danger">Module is required</span>}

                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Sub module content type</label>
                                <div className="col-sm-10">
                                <select  {...register("sublesson_status", { required: true})} className="form-control" >
                                        <option value="">Select Module Content</option> 
                                        <option value="0">PPT Slide</option>
                                        <option value="1">Quiz</option>                                           
                                        <option value="2">Video</option>
                                        <option value="3">Final Assessment</option>
                                        
                                    </select>
                                    {errors.sublesson_status && <span  className="text-danger">Sub Module is required</span>}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Sub Module Content</label>
                                <div className="col-sm-10">
                                    <input type="file" {...register('sublesson_content' ,{ required: true, maxLength: 20 })} className="form-control" />
                                    <span> {errors.firstName && errors.firstName.message}</span>

                                    {errors.sublesson_content && <span  className="text-danger">sublesson content is required</span>}

                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Sub Module Name</label>
                                <div className="col-sm-10">
                                    <input type="name" {...register("sublesson_name" ,{ required: true})} className="form-control" />
                                    {errors.sublesson_name && <span  className="text-danger">Sub Module Name is required</span>}

                                </div>
                            </div>
                        
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Sub module content type</label>
                                <div className="col-sm-10">
                                    <select  {...register("sublesson_rserial", { required: true })} className="form-control" >
                                        <option value="">Select Module Content Type</option>
                                        <option value="1">First Content in the same module</option>
                                        <option value="2">Second Content in the same module</option>
                                        <option value="3">Third Content in the same module</option>
                                    </select>
                                    {errors.sublesson_rserial && <span className="text-danger">Sub Module Content Type is required</span>}

                                </div>
                            </div>
                        
                           <div className="modal-footer">
                             {isLoading.status !='pending' ? 
                                <>
                                  <button type="submit" className="btn btn-warning">Save changes</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </>       
                                :
                                <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                }
                            </div> 
                        </form>
                        </div>
                    </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    );
}